import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, RefreshCcw } from "lucide-react";
import { api, formatApiError } from "@/lib/apiClient";

export default function AdminCashAudit() {
  const [rows, setRows] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/admin/cash/audit?limit=300"); setRows(data); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-cash-audit">
      <header className="mb-6 flex items-end justify-between">
        <div>
          <Link to="/admin/cash" className="text-xs text-brand-charcoal/60 hover:text-brand-charcoal inline-flex items-center gap-1"><ArrowLeft size={12} /> Back to Today</Link>
          <h1 className="editorial-h1 text-4xl mt-2">Audit Log</h1>
        </div>
        <button onClick={load} className="btn-pill btn-ghost text-xs"><RefreshCcw size={11} /> Refresh</button>
      </header>
      <div className="rounded-2xl bg-white border border-brand-line p-5">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-widest text-brand-charcoal/55">
            <tr><th className="text-left py-2">At</th><th className="text-left py-2">Actor</th><th className="text-left py-2">Role</th><th className="text-left py-2">Action</th><th className="text-left py-2">Date</th><th className="text-left py-2">Details</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 ? <tr><td colSpan={6} className="py-8 text-center text-brand-charcoal/50">No audit entries.</td></tr> :
              rows.map((r) => (
                <tr key={r.id} className="border-t border-brand-line" data-testid={`audit-${r.id}`}>
                  <td className="py-2 text-xs">{new Date(r.at).toLocaleString()}</td>
                  <td className="py-2 font-mono text-xs">{r.actor}</td>
                  <td className="py-2"><span className="text-[10px] uppercase tracking-widest bg-brand-yellow/20 text-brand-charcoal px-2 py-0.5 rounded-full">{r.role}</span></td>
                  <td className="py-2 text-xs">{r.action}</td>
                  <td className="py-2 font-mono text-xs">{r.date || "—"}</td>
                  <td className="py-2 text-xs text-brand-charcoal/70">{r.diff && Object.keys(r.diff).length ? <code className="bg-brand-muted/40 px-1.5 py-0.5 rounded">{JSON.stringify(r.diff)}</code> : "—"}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
